import { getAPIN8N } from "@/services/Api/n8nApiConfig";

export function useReport() {
  const Api_N8N = getAPIN8N();

  const generateBankingReport = (body: object) => {
    return Api_N8N.post(`v1/bank/statements/balance`, body);
  }
  
  return {
    generateBankingReport,
  };
}
